import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getResponsePhraseByIdThunk,
  getResponsePhrasesByPlantelThunk,
  updateResponsePhraseThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import { toast } from "react-toastify";
import {
  closeResponsePhraseEdit,
  openResponsePhraseView,
} from "../../store/reducers/plantels/responsePhrases.reducer";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";

const ResponsePhraseEditModal = ({ plantelId }) => {
  const dispatch = useDispatch();

  const { editModalOpen, selectedPhrase, editLoading, editError } = useSelector(
    (state) => state.responsePhrases,
  );

  const [formData, setFormData] = useState({
    frase: "",
    valor: 0,
  });

  useEffect(() => {
    if (selectedPhrase) {
      setFormData({
        frase: selectedPhrase.frase || "",
        valor: selectedPhrase.valor || 0,
      });
    }
  }, [selectedPhrase, editModalOpen]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(
      updateResponsePhraseThunk({
        id: selectedPhrase.id,
        payload: formData,
      }),
    );

    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getResponsePhrasesByPlantelThunk(plantelId));

      toast.success("Frase actualizada correctamente");

      await dispatch(getResponsePhraseByIdThunk(selectedPhrase.id));
      dispatch(openResponsePhraseView());
    }
  };

  return (
    <Modal
      open={editModalOpen}
      onClose={() => dispatch(closeResponsePhraseEdit())}
      title="Editar frase de respuesta"
      size="lg"
    >
      {editLoading ? (
        <Loader center type="dots" text="Actualizando frase respuesta..." />
      ) : (
        <form onSubmit={handleSubmit}>
          {editError && <Alert message={editError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={formData.frase}
              onChange={handleChange}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Valor <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              name="valor"
              value={formData.valor}
              onChange={handleChange}
              placeholder="Ingrese el valor"
              required
            />
            <small className="text-muted">
              Valor numérico asociado a esta frase
            </small>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-outline-secondary px-20 py-11"
              onClick={() => dispatch(closeResponsePhraseEdit())}
            >
              Cancelar
            </button>

            <button type="submit" className="btn btn-primary px-20 py-11">
              Actualizar
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default ResponsePhraseEditModal;
